var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapMedium = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 20C8.167 16.667 6 13.5 6 10.5a6.5 6.5 0 0113 0c0 3-2.167 6.167-6.5 9.5zm5.5-9.5a5.5 5.5 0 10-11 0c0 2.491 1.8 5.249 5.5 8.228 3.7-2.98 5.5-5.737 5.5-8.228zM12.5 14a3.5 3.5 0 110-7 3.5 3.5 0 010 7zm0-1a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
  })));
});
export default SvgMapMedium;